// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"_1nJp4","tabButtonActive":"P5hck"};